import { Labeled } from "react-admin";

import { CustomFieldField } from "./CustomFieldField";

export const CustomFieldShow = ({ field }) => {
	if (!field?.name) return null;
	return (
		<span className={`ra-field ra-field-${field.key}`}>
			<Labeled label={field?.name}>
				<CustomFieldField field={field} />
			</Labeled>
		</span>
	);
};
